var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gmail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.04688 11.6672L1.21875 17.9344V5.4563L5.87813 9.15005L9.04688 11.6672Z",
    fill: "#971EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.72346 7.83284L2.09534 4.95471H21.9047L18.2766 7.83284L13.9125 11.2922L12 12.7781L10.0875 11.2922L5.72346 7.83284Z",
    fill: "#971EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.1937 12.2625L22.6641 19.0453H1.33594L9.80625 12.2625L11.7141 13.739C11.7234 13.7484 11.7375 13.7531 11.7469 13.7625C11.9016 13.8609 12.1031 13.8609 12.2578 13.7625C12.2672 13.7531 12.2813 13.7484 12.2906 13.739L14.1937 12.2625Z",
    fill: "#971EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.7812 5.4563V17.9344L14.9531 11.6672L18.1219 9.15005L22.7812 5.4563Z",
    fill: "#971EFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.43dd87e1305bf3d9894ac5bcf22fe51f.svg";
export { ForwardRef as ReactComponent };